import { useQuery } from "@tanstack/react-query";

import { type MarketingLead } from "@fitness-app/data-models/entities/MarketingLead";

import { analyticsApi } from "~/store/initializeStore";

import { type MarketingDashboardFilters, toMarketingRequestParams } from "../marketingFilters";

const fetchLeads = async (filters: MarketingDashboardFilters) => {
  const response = await analyticsApi.get<MarketingLead[]>("/marketing/leads", {
    params: toMarketingRequestParams(filters),
  });
  return response.data;
};

export const useMarketingLeads = (filters: MarketingDashboardFilters) => {
  const { data, error, isLoading, isFetching } = useQuery(
    ["marketingLeads", filters.from, filters.to, filters.campaign, filters.rep],
    {
      keepPreviousData: true,
      queryFn: () => fetchLeads(filters),
    },
  );

  return { leads: data ?? [], error, isLoading, isFetching };
};
